"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Help2 = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Help2 = _ref => {
  let {
    color = "#8C8DA6",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm.925 13.043a1.24 1.24 0 0 1-.91.378 1.217 1.217 0 0 1-.904-.378 1.253 1.253 0 0 1-.371-.914 1.265 1.265 0 0 1 1.273-1.273c.341-.006.67.128.91.37.247.235.384.562.379.903a1.24 1.24 0 0 1-.377.914Zm1.874-6.247c.119-.2.213-.412.28-.635h.005a2.792 2.792 0 0 0-.134-1.88 2.688 2.688 0 0 0-.659-.896 3.074 3.074 0 0 0-1.015-.592 3.802 3.802 0 0 0-1.302-.215c-.411-.007-.82.064-1.205.208a3.184 3.184 0 0 0-1.577 1.288c-.164.258-.291.537-.377.83l1.703.71c.04-.16.103-.315.186-.46a1.64 1.64 0 0 1 .318-.398A1.445 1.445 0 0 1 8.03 4.37c.338-.017.667.108.91.344.213.206.333.489.334.785.008.26-.07.515-.222.726a4.593 4.593 0 0 1-.623.652c-.227.189-.442.392-.644.607-.16.17-.3.358-.416.561-.102.184-.179.38-.229.585a2.77 2.77 0 0 0-.072.659v.497h1.939V9.55a2.273 2.273 0 0 1 .045-.482c.029-.136.076-.268.14-.392.074-.136.163-.263.267-.377.104-.116.244-.26.422-.43.178-.17.346-.343.504-.516.156-.171.295-.357.415-.556Z",
    clipRule: "evenodd"
  }));
};
exports.Help2 = Help2;
Help2.displayName = "Help2";